import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Confirm, Tag} from '@wix/wix-ui-icons-common'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {ChangeEvent} from 'react'
import {FormStep} from '../../../constants'
import c from '../../classnames.scss'
import fs from '../../form/form.scss'
import {CouponError} from '../coupon-error'
import {CouponInputClearButton} from './coupon-input-clear-button'
import {CouponInputSpinner} from './coupon-input-spinner'
import s from './coupon-input.scss'
import {CouponInputProps} from '.'

const borderClass = c.formSummaryBox
const colorClass = c.formSummaryColor
const fontClass = c.formSummaryBody
const inputClass = c.formSummaryCouponInput

export const CouponInput = ({
  eventId,
  reservationId,
  discountValid,
  orderCompleted,
  showCouponInput,
  error,
  validating,
  applyCoupon,
  removeCoupon,
  currentStep,
  editStep,
}: CouponInputProps) => {
  const {t} = useTranslation()
  const [shouldInfoTextShow, setShouldInfoTextShow] = React.useState(true)
  const [couponCode, setCouponCode] = React.useState('')
  const inputRef = React.useRef<HTMLInputElement>()

  const StatusIcon = discountValid ? Confirm : Tag
  const isError = Boolean(error)
  const readOnly = discountValid || isError
  const paymentStep = currentStep === FormStep.Payment

  if (!showCouponInput) {
    return null
  }

  const submit = () => {
    if (couponCode.length) {
      applyCoupon(eventId, reservationId, couponCode)
    }
  }

  const reset = (focus: boolean) => {
    if (!focus) {
      editStep(FormStep.BuyerDetails, false)
    }
    setShouldInfoTextShow(!focus)
    setCouponCode('')
    removeCoupon()
  }

  const setCode = (e: ChangeEvent<HTMLInputElement>) => setCouponCode(e.target.value)

  const handleOnBlur = () => {
    if (!discountValid) {
      submit()
    }

    handleInfoText()
  }

  const handleInfoText = () => {
    if (couponCode) {
      return setShouldInfoTextShow(false)
    }

    setShouldInfoTextShow(!shouldInfoTextShow)
  }

  const onFocus = () => {
    if (paymentStep && !readOnly) {
      editStep(FormStep.BuyerDetails, false)
    }
    return isError ? reset(true) : handleInfoText()
  }
  return (
    <div className={classNames({[fs.summaryBlock]: !isError})}>
      <div className={classNames(s.couponInputContainer, colorClass)}>
        <div className={classNames(s.couponInfoContainer)}>
          <StatusIcon size="24px" />
          {shouldInfoTextShow ? (
            <span className={classNames(s.couponOpenButtonText, fontClass)} data-hook={DH.COUPON_INPUT_INFO}>
              {t('summary.enterCouponCode')}
            </span>
          ) : null}
        </div>
        <div
          data-hook={DH.COUPON_FORM}
          className={classNames(borderClass, s.couponBorderContainer, {
            [c.formSummaryBoxBorderColorActive]: !!couponCode?.length,
            [s.couponInputReadOnly]: orderCompleted,
          })}
        >
          <input
            type="text"
            aria-label={t('a11y.couponCodeInputField')}
            maxLength={20}
            onFocus={onFocus}
            onBlur={handleOnBlur}
            onChange={setCode}
            onKeyPress={event => event.key === 'Enter' && inputRef.current.blur()}
            data-hook={DH.COUPON_CODE_INPUT}
            className={classNames(s.couponInput, inputClass)}
            value={couponCode}
            readOnly={readOnly}
            ref={inputRef}
          />
          {readOnly ? <CouponInputClearButton onClick={() => reset(false)} /> : null}
          {validating ? <CouponInputSpinner /> : null}
        </div>
        {isError && <CouponError error={error} />}
      </div>
    </div>
  )
}
